module.exports = __webpack_public_path__ + "img/logo.1ad42c06.png";